export const INITIAL_PAGE_SIZE = 160;
export const CHILDREN_PAGE_SIZE = 100;
// with the new value of INITIAL_PAGE_SIZE being 160, PAGE_TREE_SSR_RENDER_SIZE_LIMIT is obsolete.
// We will remove PAGE_TREE_SSR_RENDER_SIZE_LIMIT and logic associated with it when we are comfortable with the performace with the new limit.
export const PAGE_TREE_SSR_RENDER_SIZE_LIMIT = 0;

export const getPageTreeSSRRenderSizeLimit = () =>
	process.env.NODE_ENV === 'production' ? PAGE_TREE_SSR_RENDER_SIZE_LIMIT : 0;
